module.exports = __webpack_public_path__ + "static/b4-e66ab7a68c725e254f0f97fffc00c31c.jpg";